import { createElementBlock as a, openBlock as l, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
};
function t(n, e) {
  return l(), a("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 .5a.5.5 0 0 1 .5.5v1.5h4V1a.5.5 0 0 1 1 0v1.667c0 .46-.373.833-.833.833H2.333a.833.833 0 0 1-.833-.833V1A.5.5 0 0 1 2 .5m.5 3.833a1 1 0 0 0-1 1v5.334a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V5.333a1 1 0 0 0-1-1zm0 1h4v5.334h-4zm7-1a1 1 0 0 0-1 1v5.334a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V5.333a1 1 0 0 0-1-1zm0 1h4v5.334h-4zM9.5 1a.5.5 0 0 0-1 0v1.667c0 .46.373.833.833.833h4.334c.46 0 .833-.373.833-.833V1a.5.5 0 0 0-1 0v1.5h-4zM14 15.5a.5.5 0 0 1-.5-.5v-1.5h-4V15a.5.5 0 0 1-1 0v-1.667c0-.46.373-.833.833-.833h4.334c.46 0 .833.373.833.833V15a.5.5 0 0 1-.5.5M6.5 15a.5.5 0 0 0 1 0v-1.667a.833.833 0 0 0-.833-.833H2.333a.833.833 0 0 0-.833.833V15a.5.5 0 0 0 1 0v-1.5h4z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const v = { render: t };
export {
  v as default,
  t as render
};
